import type { AccessRoute } from 'ui/organisms/AccessRoutes/AccessRoutes.types';

type Translate = (key: string) => string;

export const getAccessRoutes = (t: Translate): AccessRoute[] => [
  {
    name: t('Platform'),
    desc: t('Search, screen and export company records from the web application.'),
    actions: [{ label: t('Open the platform'), href: '/platform' }],
  },
  {
    name: 'API',
    desc: t(
      'Query any company by registry identifier. Documented endpoints, JSON responses, provenance on every field.',
    ),
    actions: [{ label: t('Read the API docs'), href: 'https://api.globaldatabase.com/docs/v2/#setup' }],
  },
  {
    name: t('Bulk data feeds'),
    desc: t('Full datasets and scheduled deltas, delivered to your warehouse on your cadence.'),
    actions: [{ label: t('Request a feed'), href: '/book-a-demo' }],
  },
  {
    name: 'MCP',
    desc: t('Connect the dataset to any MCP-compatible agent or tool.'),
    actions: [{ label: 'MCP server', href: '/mcp-integration' }],
  },
  {
    name: t('Assistant connectors'),
    desc: t('Pull registry data straight into the assistant your teams already use.'),
    actions: [
      { label: t('Add to Claude'), href: 'https://claude.ai/new#directory/connectors/global-database' },
      { label: t('Add to ChatGPT'), href: 'https://chatgpt.com/plugins/plugin_asdk_app_696f807d21a481918a1ed1f43d719ce9' },
    ],
  },
  {
    name: 'CRM',
    desc: t('Enrich and monitor accounts inside the system your commercial and finance teams already work in.'),
    actions: [
      { label: 'Salesforce', href: 'https://appexchange.salesforce.com/appxListingDetail?listingId=7d8cb601-add2-47f7-a345-4008cbb0cfe4' },
      { label: 'HubSpot', href: 'https://ecosystem.hubspot.com/marketplace/listing/global-database-intelligence-enrichment' },
    ],
  },
  {
    name: 'Regis AI',
    desc: t(
      'Ask in natural language across the dataset and get answers with their sources attached. The same engine runs as an API, so a compiled search strategy can execute inside your own tooling rather than only in the app.',
    ),
    actions: [
      { label: t('Meet Regis AI'), href: '/regis' },
      { label: 'Regis API', href: '/regis-api' },
    ],
  },
];
